import { useState } from "react";
import TransitContactForm from "../components/TransitContactForm";

function SixtyYearsTransit() {
  const [activeForm, setActiveForm] = useState(null);
  return (
    <div className="font-fordAntennaRegular">
      <section className="relative w-full overflow-hidden">
        {/* Мобилна снимка */}
        <img
          src="/images/sixty-years-transit/60y-transit-mobile.jpg"
          alt="60 години Ford Transit mobile"
          className="block object-cover w-full h-full md:hidden"
        />

        {/* Десктоп снимка */}
        <img
          src="/images/sixty-years-transit/60y-transit-desktop.jpg"
          alt="60 години Ford Transit desktop"
          className="hidden object-cover w-full h-full md:block"
        />

        {/* Маска само за десктоп */}
        <div className="absolute inset-0 hidden z-5 md:block bg-gradient-to-t from-black/20 to-transparent" />

        {/* Overlay текст */}
        <div className="absolute inset-0 z-10 flex flex-col justify-between w-full h-full px-4 pt-6 pb-6 text-center text-white md:justify-end md:pb-4">
          <h1 className="mt-8 text-4xl tracking-widest font-fordBold md:text-6xl md:mb-2">
            60 ГОДИНИ <br className="md:hidden" />
            FORD TRANSIT
          </h1>
          <p className="mt-2 mb-8 text-4xl tracking-widest uppercase font-fordMedium md:text-5xl md:mb-6">
            №1 В СВЕТА
          </p>
        </div>
      </section>
      <section className="max-w-6xl px-4 mx-auto mt-16">
        <p className="text-xl text-fordBlue">
          Оставайки верен на корените си – но сега още по-мощен: Ford Transit®
          съчетава доказаните си качества с най-новите технологии за свързаност
          и максимална производителност. Заедно с изцяло електрическия Ford
          E-Transit™, тези ванове предлагат подобрена функционалност,
          изключителни възможности и множество усъвършенствани функции за
          свързаност. Ford Transit е готов за всяка задача.
        </p>
      </section>
      <section className="flex flex-col justify-between max-w-6xl gap-8 px-4 mx-auto mt-16 text-center md:flex-row">
        <div>
          <p className="text-xl text-fordBlue">МАКС. ОБЕМ НА ТОВАР</p>
          <p className="mt-2 text-4xl text-fordLight font-fordBold">15,1 м³</p>
        </div>
        <div>
          <p className="text-xl text-fordBlue">МАКС. ПОЛЕЗЕН ТОВАР</p>
          <p className="mt-2 text-4xl text-fordLight font-fordBold">2447 кг</p>
        </div>
        <div>
          <p className="text-xl text-fordBlue">МАКС. ДЪЛЖИНА НА ТОВАРА</p>
          <p className="mt-2 text-4xl text-fordLight font-fordBold">4256 мм</p>
        </div>
      </section>
      <section className="flex flex-col justify-center max-w-6xl gap-8 px-4 mx-auto mt-16 text-center md:flex-row">
        <button
          onClick={() => setActiveForm("testdrive")}
          className="px-8 py-4 text-white rounded-full bg-fordBlue hover:bg-fordLight"
        >
          Заяви тестдрайв
        </button>
        <a
          href="https://sale.ford.bg/?model=TRANSIT"
          className="px-8 py-4 text-white rounded-full bg-fordBlue hover:bg-fordLight"
        >
          Виж налични автомобили
        </a>
        <button
          onClick={() => setActiveForm("offer")}
          className="px-8 py-4 text-white rounded-full bg-fordBlue hover:bg-fordLight"
        >
          Заяви оферта
        </button>
      </section>
      <section className="max-w-6xl px-4 mx-auto mt-24 text-fordBlue">
        <h3 className="text-2xl font-fordBold text-fordBlue">
          ПРАВИЛНОТО РЕШЕНИЕ ЗА ВСЯКА КОМПАНИЯ
        </h3>
        <p className="mt-4 text-xl text-fordBlue">
          Изберете перфектния Ford Transit за вашия бизнес. Изберете между три
          дължини на каросерията и две височини на покрива.
        </p>
        <div className="flex flex-col gap-8 mt-8 md:flex-row">
          <div>
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-van_base-16x9-2160x1215.png.renditions.extra-large.png"
              alt=""
              className="py-4"
            />
            <p className="mt-8 text-xl font-fordMedium">BASE</p>
            <ul className="list-disc list-inside">
              <li>Плъзгаща се врата отдясно</li>
              <li>12" мултифункционален дисплей и Ford SYNC4</li>
              <li>5G модем</li>
              <li>Система за поддържане на скорост (Cruise Control)</li>
              <li>Асистент за поддържане на лентата</li>
              <li>Система за разпознаване на пътни знаци</li>
              <li>Система за следене на налягането в гумите</li>
              <li>Задни паркинг сензори</li>
            </ul>
          </div>
          <div>
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-van_trend-16x9-2160x1215.png.renditions.extra-large.png"
              alt=""
              className="py-4"
            />
            <p className="mt-8 text-xl font-fordMedium">TREND</p>
            <ul className="list-disc list-inside">
              <li>Автоматична климатизация</li>
              <li>Светлини за мъгла</li>
              <li>Система за паркиране отпред</li>
              <li>Отопляемо предно стъкло</li>
              <li>Външни огледала, електрически регулируеми и отопляеми</li>
              <li>Пълни декоративни тасове</li>
              <li>Задна камера</li>
              <li>Високо монтирани LED светлини в задната централна част</li>
            </ul>
          </div>
          <div>
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-panelvanlimited21_0_24.75MY_Wheels_2-16x9-2160x1215.png.renditions.extra-large.png"
              alt=""
              className="py-4"
            />
            <p className="mt-8 text-xl font-fordMedium">LIMITED</p>
            <ul className="list-disc list-inside">
              <li>Навигация с онлайн свързаност</li>
              <li>Би-ксенонови фарове</li>
              <li>Адаптивен круиз контрол</li>
              <li>Леки алуминиеви джанти</li>
              <li>Камера с 360° изглед</li>
              <li>Асистент за следене на сляпа зона</li>
              <li>Асистент за аварийно спиране при движение назад</li>
            </ul>
          </div>
        </div>
      </section>
      <section className="max-w-6xl px-4 mx-auto mt-24 text-fordBlue">
        <h3 className="text-2xl font-fordBold text-fordBlue">
          СЪЗДАДЕН ЗА ЕФЕКТИВНОСТ
        </h3>
        <p className="mt-4 text-xl text-fordBlue">
          Предлага се с избор между електрическо или дизелово задвижване
          EcoBlue.
        </p>
        <div className="flex flex-col gap-8 mt-8 md:flex-row">
          <div className="flex flex-col justify-center">
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cars/hybrid-electric/ford-eu-gux-EV_Logos_new_ALL_ELECTRIC_16x9-2160x1215.png.renditions.extra-large.png"
              alt=""
              className="rounded-xl"
            />
            <ul className="mt-8 text-center">
              <li className="py-2 border-b border-b-gray-200">
                До 402 км електрически пробег
              </li>
              <li className="py-2 border-b border-b-gray-200">
                Наличен с 68 kWh (стандартен пробег) или 89 kWh (удължен пробег)
                батерия
              </li>
              <li className="py-2 border-b border-b-gray-200">
                430 Nm въртящ момент
              </li>
              <li className="py-2 border-b border-b-gray-200">
                Задно задвижване
              </li>
              <li className="py-2 border-b border-b-gray-200">
                Наличен с Pro Power Onboard захранване 2.3 kW
              </li>
            </ul>
            <button className="px-8 py-4 mt-8 text-white rounded-full hover:bg-fordBlue bg-fordLight md:max-w-[50%] mx-auto">
              <a href="https://ford.bg/commercial_cars/e-transit">
                Открий E-Transit
              </a>
            </button>
          </div>
          <div>
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2023-transit-fvp/features/ford-ICE-eu-ICE-Logos-Diesel-fc_ccl_16x9-2160x1215-ice-logo.jpg.renditions.extra-large.jpeg"
              alt=""
              className="rounded-xl"
            />
            <ul className="mt-8 text-center">
              <li className="py-2 border-b border-b-gray-200">
                2.0L EcoBlue дизелов двигател
              </li>
              <li className="py-2 border-b border-b-gray-200">
                Наличен в три нива на мощност — от 105 к.с. до 165 к.с.
              </li>
              <li className="py-2 border-b border-b-gray-200">
                Въртящ момент от 310 Nm до 390 Nm
              </li>
              <li className="py-2 border-b border-b-gray-200">
                Предно, задно или двойно (4х4) задвижване
              </li>
              <li className="py-2 border-b border-b-gray-200">
                6-степенна ръчна или 8- / 10-степенна автоматична трансмисия
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="max-w-6xl px-4 mx-auto mt-24 text-fordBlue">
        <h3 className="text-2xl font-fordBold text-fordBlue">
          УПРАВЛЯВАЙТЕ ЕЖЕДНЕВИЕТО С ЛЕКОТА
        </h3>
        <div className="flex flex-col gap-8 mt-8 md:flex-row">
          <div className="flex-1">
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-03_V363_23Spec_Update_REAR_3QTR_RT2_V5_1_transit-16x9-2160x1215-FC.jpg.renditions.extra-large.jpeg"
              alt=""
              className="rounded-xl"
            />
            <h4 className="mt-4 text-xl font-fordMedium">ВЪНШЕН ДИЗАЙН</h4>
            <p className="mt-2 text-fordBlue">
              Нова предна ос и по-леки елементи на каросерията увеличават
              товароносимостта. Подобреното окачване и по-големите 16-инчови
              колела осигуряват по-голям комфорт и издръжливост.
            </p>
          </div>
          <div className="flex-1">
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-14_V363_ETransit_Detail_Rotary_Gears-16x9-2160x1215-FC.jpg.renditions.extra-large.jpeg"
              alt=""
              className="rounded-xl"
            />
            <h4 className="mt-4 text-xl font-fordMedium">
              АВТОМАТИЧНА ТРАНСМИСИЯ
            </h4>
            <p className="mt-2 text-fordBlue">
              Подобрената 8-степенна автоматична трансмисия заменя предишната
              6-степенна версия. Въртящият се селектор на скоростите, разположен
              в централната конзола, и перата за смяна на скоростите на волана
              осигуряват лесно и удобно превключване.
            </p>
          </div>
          <div className="flex-1">
            <img
              src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-V363_23Spec_Update_46171_R_47275_V2_transit-16x9-2160x1215-FC.jpg.renditions.extra-large.jpeg"
              alt=""
              className="rounded-xl"
            />
            <h4 className="mt-4 text-xl font-fordMedium">
              АСИСТЕНТИ ЗА ШОФИРАНЕ
            </h4>
            <p className="mt-2 text-fordBlue">
              Нашите най-модерни системи за подпомагане на водача включват
              Асистент за предотвратяване на сблъсък, Круиз контрол, Асистент за
              поддържане на лентата, Интелигентен ограничител на скоростта,
              Асистент за фарове и Система за следене на налягането в гумите —
              стандартно оборудване.Правим всичко необходимо, за да осигурим
              вашето безопасно и комфортно пътуване.
            </p>
          </div>
        </div>
      </section>
      <section className="flex flex-col max-w-6xl gap-8 px-4 mx-auto mt-24 md:flex-row text-fordBlue">
        <img
          src="https://www.ford.de/content/dam/guxeu/rhd/central/cvs/2019-transit-van/update-ice/features/ford-transit-eu-09_V363_BEV_MY24_Interior_SYNC4_Pre_Condition-16x9-2160x1215-FC.jpg.renditions.small.jpeg"
          alt=""
          className="md:max-w-[50%] rounded-xl"
        />
        <div className="flex-1">
          <h4 className="text-xl font-fordMedium">FORD SYNC 4</h4>
          <p className="mt-2 text-fordBlue">
            12-инчовият сензорен екран може да се свърже едновременно с два
            смартфона, предлагайки още по-плавно, свързано и персонализирано
            изживяване при шофиране.
            <br />
            Включва Apple CarPlay и Android Auto, гласово управление, базирано в
            облака, и още много функции.
          </p>
        </div>
      </section>
      <section className="max-w-6xl px-4 mx-auto mt-24">
        <div className="relative overflow-hidden aspect-video rounded-xl">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src="https://www.youtube.com/embed/QdLCZLzOkvE?autoplay=1&mute=1&enablejsapi=1&origin=https://sale.ford.bg&rel=0"
            title="60 години Ford Transit"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          ></iframe>
        </div>
      </section>
      <section className="max-w-6xl p-8 px-4 mx-auto mt-16 mb-16 bg-gray-200 text-fordBlue rounded-xl">
        <a href="https://ford.bg/articles/9833-60-godini-ford-transit">
          <h3 className="text-xl tracking-wider font-fordBlack">
            60 години движение напред. 60 години Transit.
          </h3>
          <p className="mt-4">
            От първия модел до E-Transit – символ на сила, издръжливост и
            доверие.
            <br />
            Открий историята зад най-обичания ван в света.
          </p>
          <button className="px-4 py-2 mt-4 text-white rounded-full hover:bg-fordBlue bg-fordLight">
            <a href="https://ford.bg/articles/9833-60-godini-ford-transit">
              Прочети повече
            </a>
          </button>
        </a>
      </section>
      {activeForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
          <div className="relative w-full max-w-md mx-4 bg-white rounded-lg">
            <button
              onClick={() => setActiveForm(null)}
              className="absolute text-gray-500 top-3 right-3 hover:text-black"
            >
              ✕
            </button>
            <TransitContactForm
              formType={activeForm}
              onClose={() => setActiveForm(null)}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default SixtyYearsTransit;
